import iBS03T_ResultType from '../model/iBS03T_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS03T_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "temperature", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS03T_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS03T_Result;
